import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function AcceptInvitation() {
  const [token, setToken] = useState(() => window.location.hash.slice(1));
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => { window.history.replaceState(null, "", window.location.pathname); }, []);
  const submit = async (event) => {
    event.preventDefault();
    if (busy) return;
    setError("");
    if (password !== confirmation) { setError("De wachtwoorden zijn niet gelijk."); return; }
    if (Array.from(password).length < 12 || new TextEncoder().encode(password).length > 72) { setError("Gebruik minimaal 12 tekens en maximaal 72 UTF-8 bytes."); return; }
    setBusy(true);
    try {
      await api.post("/auth/accept-invitation", { token, password });
      setToken(""); setPassword(""); setConfirmation(""); setDone(true);
    } catch (e) { setError(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return <main className="min-h-screen flex items-center justify-center bg-background p-5"><section className="w-full max-w-md space-y-5 rounded-xl border bg-card p-7">
    <h1 className="text-2xl font-semibold">Welkom bij het THRM portal</h1>
    {done ? <><p>Je wachtwoord is ingesteld. Je kunt nu inloggen.</p><a href="/login" className="text-primary underline">Naar inloggen</a></> : !token ? <p>Deze uitnodigingslink ontbreekt of is niet meer beschikbaar. Vraag de beheerder om een nieuwe link.</p> : <form onSubmit={submit} className="space-y-4">
      <p>Kies je eigen wachtwoord van minimaal 12 tekens. De uitnodiging is 48 uur geldig en eenmalig te gebruiken.</p>
      <label className="block">Wachtwoord<input className="mt-1 w-full rounded border bg-background p-2" type="password" autoComplete="new-password" required value={password} onChange={(e) => setPassword(e.target.value)} /></label>
      <label className="block">Herhaal wachtwoord<input className="mt-1 w-full rounded border bg-background p-2" type="password" autoComplete="new-password" required value={confirmation} onChange={(e) => setConfirmation(e.target.value)} /></label>
      {error && <p role="alert" className="text-destructive">{error}</p>}
      <Button type="submit" disabled={busy}>{busy ? "Bezig…" : "Wachtwoord instellen"}</Button>
    </form>}
  </section></main>;
}
